import axios from '@/utils/request'
import base from '@/api/base'

/**
 * 客服工作台：会话队列 / 消息 / 转接（controller/agent：/v1/agent/**）
 */

/** 我的会话（agentId 为当前客服） */
export function getMySessions(agentId) {
  return axios.get(`${base.url}/service/v1/agent/${agentId}/sessions`)
}

/** 排队概况（queueSize + 会话列表） */
export function getQueue() {
  return axios.get(`${base.url}/service/v1/agent/queue`)
}

/** 从队列接入一个会话 */
export function pickSession(agentId) {
  return axios.post(`${base.url}/service/v1/agent/${agentId}/pick`)
}

/** 客服发送消息 */
export function sendAgentMessage(agentId, sessionId, body) {
  return axios.post(`${base.url}/service/v1/agent/${agentId}/sessions/${sessionId}/send`,
    JSON.stringify(body),
    { headers: { 'Content-Type': 'application/json' } })
}

/** 关闭会话（closeCategory: no_conversation / valid_conversation） */
export function closeAgentSession(agentId, sessionId, closeCategory) {
  return axios.post(`${base.url}/service/v1/agent/${agentId}/sessions/${sessionId}/close`,
    JSON.stringify({ closeCategory }),
    { headers: { 'Content-Type': 'application/json' } })
}

/** 全部活跃会话（主管旁听） */
export function getAllActiveSessions() {
  return axios.get(`${base.url}/service/v1/agent/sessions/all-active`)
}

/** 标记会话已读 */
export function markSessionRead(agentId, sessionId, lastReadMsgId) {
  return axios.post(`${base.url}/service/v1/agent/${agentId}/sessions/${sessionId}/read`,
    JSON.stringify({ lastReadMsgId: lastReadMsgId + '' }),
    { headers: { 'Content-Type': 'application/json' } })
}

/** 会话消息历史（与挂件共用端点） */
export function getSessionMessages(sessionId) {
  return axios.get(`${base.url}/service/v1/chat/sessions/${sessionId}/messages`)
}

/** 转接会话（返回 { transferId, expiresInSeconds }） */
export function transferSession(agentId, sessionId, targetAgentId) {
  return axios.post(`${base.url}/service/v1/agent/${agentId}/sessions/${sessionId}/transfer`,
    JSON.stringify({ targetAgentId }),
    { headers: { 'Content-Type': 'application/json' } })
}

/** 接收转接 */
export function acceptTransfer(transferId) {
  return axios.post(`${base.url}/service/v1/agent/transfer/${transferId}/accept`)
}

/** 拒绝转接 */
export function rejectTransfer(transferId) {
  return axios.post(`${base.url}/service/v1/agent/transfer/${transferId}/reject`)
}

/** 转移超时 */
export function timeoutTransfer(transferId) {
  return axios.post(`${base.url}/service/v1/agent/transfer/${transferId}/timeout`)
}

/** 可转接客服列表 */
export function getTransferableAgents(agentId) {
  return axios.get(`${base.url}/service/v1/agent/${agentId}/transferable`)
}